<template>
  <div class="box risk">
    <component :is="curr" ref="riskEditView"></component>
    <component
      :is="findThing"
      :visible="showDialog"
      @close="closeDialog"
      :ajax="listAjax"
    ></component>
  </div>
</template>

<script>
import baseHospital from './components/baseHospital';
import lvlHospital from './components/lvlHospital';
import otc from './components/otc';
import academy from './components/academy';
import digital from './components/digital.vue';
import editScene from './components/editScene.vue';
import dialogRisk from './components/dialog.vue';
import elseComponent from './components/else.vue';
import { getStorage } from '@/tools/storage';
import { mapState } from 'vuex';
import { judge } from '@/Mixin/judge';
import digitalSurvey from './components/digitalSurvey';
import investigateAndSurvey from './components/investigateAndSurvey.vue';
export default {
  mixins: [judge],
  name: 'riskManage',
  data() {
    return {
      componentMap: {},
      curr: 'academy',
      findThing: '',
      showDialog: false,
      listAjax: null,
      list: [],
      range: {},
      dialogQuery: {},
      user: {},
      map: {
        academy: {
          ajaxKey: 'Xsbf',
          base: ''
        },
        baseHospital: {
          ajaxKey: 'Jcyljg',
          base: ''
        },
        lvlHospital: {
          ajaxKey: 'Djyy',
          base: ''
        },
        otc: {
          ajaxKey: 'Otc',
          base: ''
        },
        digital: {
          ajaxKey: 'Szbf',
          base: ''
        },
        elseComponent: {
          ajaxKey: 'Szbf',
          base: ''
        },
        editScene: {
          ajaxKey: 'MakeScene',
          base: ''
        }
      }
    };
  },
  computed: {
    ...mapState({
      projectId: state => state.homeProject.id,
      projectType: state => state.homeProject.projectType
    }),
    currOption() {
      let option = this.map[this.curr];
      let base = `riskBase${option.ajaxKey}Control`;
      let saas = `riskSaas${option.ajaxKey}Control`;
      return { ...option, base, saas };
    }
  },
  provide() {
    return {
      riskIndex: this
    };
  },
  components: {
    digitalSurvey,
    baseHospital,
    lvlHospital,
    otc,
    academy,
    editScene,
    dialogRisk,
    digital,
    elseComponent,
    investigateAndSurvey
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
    }
  },
  created() {
    this.user = getStorage('user') || {};
    this.dialogQuery = {
      projectType: this.projectType,
      projectId: this.projectId,
      enterpriseId: this.user.enterpriseId
    };
    let componentMap = {
      1: 'academy',
      2: 'otc',
      5: 'investigateAndSurvey',
      10: 'baseHospital',
      9: 'lvlHospital',
      17: 'digital',
      20: 'editScene',
      21: 'digitalSurvey'
    };
    this.curr = componentMap[this.projectType] || 'elseComponent';
  }
};
</script>

<style scoped lang="scss">
.risk {
  padding: 31px 27px;
  height: 100%;
  background: #ffffff;

  .el-form-item {
    padding: 15px 0;
    margin-bottom: 0;
    border-bottom: 1px solid #f2f6fc;
    max-width: 1070px;

    .form-item-flex {
      display: flex;
      align-items: center;
    }
  }

  // 控制表格内suffix位置与显色
  .rmgt {
    padding-top: 25px;
    padding-bottom: 15px;

    .el-input__suffix {
      right: 12px;
      color: #000;
    }
  }

  .note-d1 {
    font-size: 13px;
    margin-left: 220px;
    color: #c0c4cc;

    span {
      color: #f53273;
    }
  }

  // 注释文字
  .note-s1 {
    margin-left: 30px;
    font-size: 13px;
    color: #c0c4cc;
  }

  // 任务距离
  .distance {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .distance:last-child {
    margin-bottom: 0;
  }

  // 勾选
  .check {
    position: absolute;
    right: 0;
  }

  // 连接
  .line {
    width: 16px;
    height: 1px;
    background: #dedede;
    margin: 0 12px;
    display: inline-block;
  }

  // 按钮
  .bts-div {
    margin-top: 40px;
    margin-left: 220px;

    .b {
      margin-right: 88px;
    }
  }
}
</style>
